// copyright https://www.npmjs.com/package/@unseenco/e

import SelectorSet from 'selector-set'


export class EventType {
  static KEY_DOWN = 'key_down'
  static KEY_UP = 'key_up'
  static KEY_PRESS = 'key_press'
  static RESIZE = 'resize'
  static VISIBILITY = 'visibility'
  static PROGRESS = 'progress'
  static COMPLETE = 'complete'
  static UPDATE = 'update'
  static HOVER = 'hover'
  static CLICK = 'click'
  static INIT = 'init'
  static SCROLL_RESIZE = 'SCROLL_RESIZE'
  static SCROLL_SYNC = 'SCROLL_SYNC'
  static SCROLL_INIT = 'SCROLL_INIT'
  static MOUSE_DRAG = 'MOUSE_DRAG'
  static MOUSE_UPDATE = 'MOUSE_UPDATE'
  static FORCE_RESIZE = 'FORCE_RESIZE'
  static NAVIGATE_OUT = 'NAVIGATE_OUT'
  static NAVIGATE_IN = 'NAVIGATE_IN'
  static NAVIGATE_END = 'NAVIGATE_END'
  static DOM_CHANGE = 'DOM_CHANGE'
  static FONT_RESIZE = 'FONT_RESIZE'
  static ANIMATE_IN = 'ANIMATE_IN'
  static VIDEO_PLAY = 'VIDEO_PLAY'
  static VIDEO_PAUSE = 'VIDEO_PAUSE'
  static MODAL_OPEN = 'MODAL_OPEN'
  static MODAL_SHOW = 'MODAL_SHOW'
  static LOADER_DONE = 'LOADER_DONE'
  static MOBILE_MODE = 'MOBILE_MODE'
  static FILTER_BLOG_INIT = 'FILTER_BLOG_INIT'
  static MODULE_FORM_RESET = 'MODULE_FORM_RESET'
}

const eventTypes = {}
const listeners = {}
const nonBubblers = ['mouseenter', 'mouseleave', 'pointerenter', 'pointerleave', 'blur', 'focus']

function makeBusStack(event) {
    if (listeners[event] === undefined) {
        listeners[event] = []
    }
}

function triggerBus(event, args) {
    if (listeners[event]) {
        for (let i = 0; i < listeners[event].length; i++) {
            listeners[event][i](...args)
        }
    }
}

function maybeRunQuerySelector(el) {
    return typeof el === 'string' ? document.querySelectorAll(el) : el
}

function handleDelegation(e) {
    let matches = traverse(eventTypes[e.type], e.target)

    if (matches.length) {
        for (let i = 0; i < matches.length; i++) {
            for (let i2 = 0; i2 < matches[i].stack.length; i2++) {
                if (nonBubblers.indexOf(e.type) !== -1) {
                    addDelegateTarget(e, matches[i].delegatedTarget)
                    if (e.target === matches[i].delegatedTarget) {
                        matches[i].stack[i2].data(e)
                    }
                } else {
                    addDelegateTarget(e, matches[i].delegatedTarget)
                    matches[i].stack[i2].data(e)
                }
            }
        }
    }
}

function traverse(listeners, target) {
    const queue = []
    let node = target

    do {
        if (node.nodeType !== 1) {
            break
        }

        const matches = listeners.matches(node)

        if (matches.length) {
            queue.push({delegatedTarget: node, stack: matches})
        }
    } while ((node = node.parentElement))

    return queue
}

function addDelegateTarget(event, delegatedTarget) {
    Object.defineProperty(event, 'currentTarget', {
        configurable: true,
        enumerable: true,
		get: () => delegatedTarget
    })
}

function clone(object) {
	return JSON.parse(JSON.stringify(object))
}

class E {
    bindAll(context, methods) {
        if (!methods) {
            methods = Object.getOwnPropertyNames(Object.getPrototypeOf(context))
        }

        for (let i = 0; i < methods.length; i++) {
            context[methods[i]] = context[methods[i]].bind(context)
        }
    }

    on(event, el, callback, options) {
        // TODO check error
        if(!el) {
            return;
        }

        const events = event.split(' ')

        for (let i = 0; i < events.length; i++) {
            if (typeof el === 'function' && callback === undefined) {
                makeBusStack(events[i])
                listeners[events[i]].push(el)
                continue
            }

            if (el.nodeType && el.nodeType === 1 || el === window || el === document) {
                el.addEventListener(events[i], callback, options)
                continue
            }

            el = maybeRunQuerySelector(el)

            for (let n = 0; n < el.length; n++) {
                el[n].addEventListener(events[i], callback, options)
            }
        }
    }

    delegate(event, delegate, callback) {
        const events = event.split(' ')

        for (let i = 0; i < events.length; i++) {
            let map = eventTypes[events[i]]

            if (map === undefined) {
                map = new SelectorSet()
                eventTypes[events[i]] = map

                if (nonBubblers.indexOf(events[i]) !== -1) {
                    document.addEventListener(events[i], handleDelegation, true)
                } else {
                    document.addEventListener(events[i], handleDelegation)
                }
            }

            map.add(delegate, callback)
        }
    }

    off(event, el, callback, options) {
        const events = event.split(' ')

        for (let i = 0; i < events.length; i++) {
            if (el === undefined) {
                listeners[events[i]] = []
                continue
            }

            if (typeof el === 'function') {
                makeBusStack(events[i])

                for (let n = 0; n < listeners[events[i]].length; n++) {
                    if (listeners[events[i]][n] === el) {
                        listeners[events[i]].splice(n, 1)
                    }
                }
                continue
            }

            const map = eventTypes[events[i]]

            if (map !== undefined) {
                map.remove(el, callback)

                if (map.size === 0) {
                    delete eventTypes[events[i]]

                    if (nonBubblers.indexOf(events[i]) !== -1) {
                        document.removeEventListener(events[i], handleDelegation, true)
                    } else {
                        document.removeEventListener(events[i], handleDelegation)
                    }
                    continue
                }
            }

            if (el.removeEventListener !== undefined) {
                el.removeEventListener(events[i], callback, options)
                continue
            }

            el = maybeRunQuerySelector(el)

            for (let n = 0; n < el.length; n++) {
                el[n].removeEventListener(events[i], callback, options)
            }
        }
    }

    emit(event, ...args) {
        triggerBus(event, args)
    }

    debugDelegated() {
        return clone(eventTypes)
    }

    debugBus() {
        return clone(listeners)
    }
}

export const Events = new E()